import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';

import { useMemo } from 'react';

import { getUerContractHasOthersGql } from '../contractOthersQueries';

export const useHasOthers = (contractId: number | undefined, withEffect = true) => {
    const variables = useMemo(
        () => ({
            contractId,
        }),
        [contractId],
    );

    const [getContractHasOthersData, getContractHasOthersStatus] = useRequest({
        requestId: 'getContractHasOthers',
        query: getUerContractHasOthersGql,
        withEffect: Boolean(contractId) && withEffect,
        variables,
    });

    return useMemo(
        () =>
            getContractHasOthersStatus === RequestStatus.SUCCESS &&
            getContractHasOthersData?.uerContract?.data?.hasOthers,
        [getContractHasOthersData?.uerContract?.data?.hasOthers, getContractHasOthersStatus],
    );
};
